import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verification-bank-card',
  templateUrl: './verification-bank-card.component.html',
  styleUrls: ['./verification-bank-card.component.scss']
})
export class VerificationBankCardComponent implements OnInit {

  @Input() firstName: string;
  @Input() companyName: string;
  @Input() lastName: string;
  @Input() cellPhone: string;
  @Input() requestDate: string;
  @Input() id: number;

  constructor( public router: Router) { }

  ngOnInit(): void {
  }

}
